<template>
  <div class="scroll">
    <article class="contents">
      <div class="form">
        <div class="form-row">
          <input-text
            id="lcalBnkBrnEngName"
            :value.sync="lcalBnkBrnEngName"
            labelI18n="MPRS-02-02-02-05"
            required
          />
        </div>
        <div class="form-row">
          <input-text
            id="inquiryAcno"
            :value.sync="inquiryAcno"
            labelI18n="MPRS-02-02-02-05"
            required
            alphaNum
            :maxByte="20"
          />
        </div>
        <div class="form-row">
          <input-text
            id="inquiryDpstrName"
            :value.sync="inquiryDpstrName"
            labelI18n="MPRS-02-02-02-05"
            required
            localeCase3
            :maxByte="70"
          />
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["sessionInfo"]),
  },
  data() {
    return {
      value: "",
      lcalBnkBrnEngName: "",
      inquiryAcno: "",
      inquiryDpstrName: "",
      mnrcvInfo: {
        mnrcvAcnAls: "",
        mnrcvAcno: "",
        mnrcvCncycd: "",
        mnrcvDpstrName: "",
        mnrcvOthrBnkName: "",
        mnrcvSerno: "",
        rcevnBnkIfscCode: "",
        mnrcvBrnName: "",
      },
    };
  },
  methods: {
    setInfo() {
      this.mnrcvInfo = {
        mnrcvAcnAls: "",
        mnrcvAcno: this.inquiryAcno,
        mnrcvCncycd: this.sessionInfo.userInfo.baseCncycd,
        mnrcvDpstrName: this.inquiryDpstrName,
        mnrcvOthrBnkName: this.lcalBnkBrnEngName,
        mnrcvSerno: "",
        rcevnBnkIfscCode: "",
        mnrcvBrnName: "",
      };
      return this.mnrcvInfo;
    },
  },
};
</script>